import Model, { ID, IsoDateTime, MODEL_LEVEL } from 'src/models/model'

export default class ThirdPartyTransaction extends Model {
  static name = 'ThirdPartyTransaction'

  static deletable = true

  static versioned = true

  static level = MODEL_LEVEL.CIRCUIT

  static paginate = true

  static employeeRequiredPermissionCategories = [Model.permissionCategories.ThirdPartyRewardConfig]

  static define () {
    this.fields = {
      id: {
        type: ID,
        sortable: true
      },
      providerName: {
        type: String,
        output: true
      },
      operationType: {
        type: String,
        output: true
      },
      status: {
        type: String,
        output: true
      },
      requestPayload: {
        type: String,
        output: true
      },
      responsePayload: {
        type: String,
        output: true
      },
      errorMessage: {
        type: String,
        output: true
      },
      createdAt: {
        type: IsoDateTime,
        output: true
      },
      updatedAt: {
        type: IsoDateTime,
        output: true
      }
    }
  }
}
